import { parsePhoneNumber } from 'libphonenumber-js/mobile';

export const checkPhoneValidation = (number: string) => {
	try {
		if (!number) return false;
		const phoneNumber = parsePhoneNumber(number);
		return phoneNumber && phoneNumber.isValid() ? true : false;
	} catch (error) {
		return false;
	}
};
